import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            w: '100%',
            backgroundColor: 'background.brand',
        },
        main: {
            m: {base: 0, xl: '0 auto'},
            maxW: remCalc(1400),
            direction: {base: 'column-reverse', md: 'row'},
            px: {base: 'small.base', md: 'small.md', xl: 0},
            py: {base: 'large.base', md: 'small.md'},
            gap: {base: 'small.base', md: 'small.md'},
            alignItems: {xl: 'center'},
        },
        imagebox: {
            flexGrow: 0,
            flexShrink: 0,
            flexBasis: {base: '100%', md: remCalc(229), lg: remCalc(226), xl: remCalc(213)},
        },
        image: {},
        textblock: {
            flexDirection: 'column',
            textAlign: {base: 'center', md: 'left'},
            gap: {base: 'xsmall.base', lg: 'xsmall.lg', xl: 'small.lg'},
            alignItems: {base: 'center', md: 'flex-start'},
        },
        heading: {
            textStyle: 'head-large',
            fontWeight: 'medium',
            color: 'text.inverse',
        },
        bodycopy: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
            color: 'text.inverse',
        },
        cta: {
            textDecoration: 'none !important',
            w: {base: remCalc(227), md: remCalc(310), lg: remCalc(213)},
        },
    },
}
